module.exports = __webpack_public_path__ + "static/media/meter-moderately-conservative.3db0fe60.svg";